/* eslint-disable react/prop-types */
import React, { useRef, useState } from 'react';
import PrescriptionLogo from '../../../assets/Prescription.png'
import { TbHeartPlus } from 'react-icons/tb'
import { GrLocationPin } from 'react-icons/gr'
import './Header.scss'
import { useNavigate, useParams } from 'react-router-dom';
import { Fragment } from 'react';
import PrescriptionModal from './PrescriptionModal';
import moment from 'moment';
import Modal from '../../../components/Modal'
import SelectAddress from '../../../components/SelectAddress';
import { CustomModalForm } from '../../../components/modal-forms';
import CreateAddress from '../../../components/modal-forms/create-address';
import useModal from '../../../hooks/custom-hooks/useModal';
import { toast } from 'react-toastify';
import { request } from '../../../config/helpers/axios-instance';
// import PaymentLinkModal from '../../../components/payment-link/PaymentLinkModal';
// import { useAddModalMain } from '../../../contexts/address-modal/AddModal';
import { checkForShowMissingTimingsError } from '../../../utils/orderUtils';
import GetAddressByUserMappingId from '../../../hooks/fetch-hooks/get-address-by-userid/get-address-by-userid';



const Header = ({ userData, updatePrescription, refetch, order, isEditable }) => {
    const navigate = useNavigate();
    const { quotationId } = useParams();
    const [showPrescriptionModal, setShowPrescriptionModal] = useState(false);
    const [modal, setModal] = useState(false);
    const handleShowPrescriptionModal = () => setShowPrescriptionModal(true);
    const handleClosePrescriptionModal = () => { setShowPrescriptionModal(false) };
    const { isShowing: isCreateFormShowing, toggle: toggleCreateAddressForm } = useModal();
    // const { , AddcloseModal } = useAddModalMain();

    const mappingId = order?.mappingId;
    const {
        data: patientAddress,
    } = GetAddressByUserMappingId(mappingId);
    // const [OrderData, setOrderData] = useState(null);

    // useEffect(() => {
    //     (async () => {
    //         try {
    //             let orderResponse = await request({
    //                 url: `userOrder/admin/orderDetails/${orderId}`,
    //                 method: "GET",
    //             });
    //             if (orderResponse?.data && orderResponse?.data?.data) {
    //                 setOrderData(orderResponse?.data?.data);
    //                 return toast.success("Order data fetched successfully")
    //             }
    //             toast.error("Check order data and try again")
    //         } catch (err) {
    //             toast.error("Check order data and try again")
    //         }
    //     })()
    // }, [orderId])

    function toggleModal() {
        setModal(!modal);
    }

    const [isSyncingLsq, setIsSyncingLsq] = useState(false);
    const [isConverting, setIsConverting] = useState(false);
    // A ref, not just the state: a second click can land before React re-renders with
    // isConverting=true, and the server has no guard against two concurrent conversions.
    const convertInFlight = useRef(false);

    const handleSyncLsqMappingId = async () => {
        setIsSyncingLsq(true);
        try {
            const res = await request({
                url: `quotation/admin/syncLsqMappingId/${quotationId}`,
                method: 'POST',
            });
            if (res?.data?.success) {
                toast.success('LSQ mapping ID synced successfully');
            } else {
                toast.error('Failed to sync LSQ mapping ID');
            }
        } catch (err) {
            toast.error('Failed to sync LSQ mapping ID');
        } finally {
            setIsSyncingLsq(false);
        }
    };

    // Convert to Order
    const handleConvertToOrder = async (data) => {
        if (convertInFlight.current) return
        if (!data.channel) {
            toast.error("Channel is required")
            return
        }
        convertInFlight.current = true
        setIsConverting(true)
        try {
            let res = await request({
                url: `quotation/admin/convertToOrder/${data?.id}`,
                method: "POST"
            })
            if (res && res.data.success) {
                toast.success("Quotation converted to order successfully")
                refetch()
            } else {
                toast.error("Failed to convert quotation to order")
            }
        } finally {
            convertInFlight.current = false
            setIsConverting(false)
        }
    };

    // const handleSendPaymentLink = async (data) => {
    //     try {
    //         let res = await request({
    //             url: data?.isCash ? '/payment/admin/addCashPayment' : '/payment/admin/generatePaymentLink',
    //             method: "POST",
    //             headers: {
    //                 "Content-Type": "application/json",
    //             },
    //             data: {
    //                 "quotationId": parseInt(data?.id),
    //                 "userId": data?.user?.userId,
    //                 "amount": parseFloat(data?.amount),
    //                 "gateway": data?.isCash ? "CASH" : "PAYU",
    //                 "currency": "INR",
    //                 "user": {
    //                     "name": data?.user?.name,
    //                     "phone": data?.user?.phone
    //                 }
    //             }
    //         })

    //         if (res && res.data.success) {
    //             toast.success("Payment link sent successfully")
    //             AddcloseModal()
    //             refetch()
    //         } else {
    //             toast.error("Failed to send payment link")
    //         }
    //         return res
    //     } catch (err) {
    //         toast.error("Failed to send payment link")
    //     }
    // }

    // async function handlePaymentLinkModal(order) {
    //     AddopenModal(() => <PaymentLinkModal handleSendPaymentLink={handleSendPaymentLink} orderData={order} onClose={AddcloseModal} isQuotation={true} />)
    // }

    return (
        <Fragment>
            {modal && <Modal title={"Select Address"} onClose={toggleModal}>
                <SelectAddress
                    orderData={order}           // Changed from user={userData}
                    user={userData.User}        // Changed to match order version
                    orderId={quotationId}
                    isQuotation={true}
                    closeModal={toggleModal}
                    refetch={refetch}
                    toggleCreateAddressForm={toggleCreateAddressForm}
                />
            </Modal>}
            <CustomModalForm
                isShowing={isCreateFormShowing}
                hide={toggleCreateAddressForm}
                title="Create User"
                style={{ width: "60%", maxWidth: "60%" }}
                className="modal-form">
                <CreateAddress refetch={refetch} selectedUser={userData.User} toggle={toggleCreateAddressForm} optional={toggleModal} />
            </CustomModalForm>
            <PrescriptionModal updatePrescription={updatePrescription} onClose={handleClosePrescriptionModal} show={showPrescriptionModal} prescription={userData.prescription} />

            <div className='bg-[white] px-10 py-3 rounded-lg border border-gray-300' >
                <div className='flex flex-row flex-grow basis-0 justify-around items-center gap-4' >
                    <div className='header_order-number' >
                        #{quotationId}
                    </div>
                    <div className='flex justify-center gap-3 flex-auto' >
                        <div className='relative flex justify-around items-center gap-3 border-2 px-4 py-3 rounded-lg'>
                            <div className='name-logo' >
                                {userData.User.name.split(' ')
                                    .map(word => word.charAt(0))
                                    .join('')
                                }
                            </div>
                            <div >
                                <strong className='text-md' >{userData.User.name}</strong>
                                <p className='text-sm'>{userData.User.contact_no}</p>
                                <p className='text-sm'>{moment().diff(moment(userData.User.dob), 'years') + ' years'}</p>
                                <p className='text-sm'>{userData.User.gender}</p>
                            </div>
                            <div className='absolute right-2 bottom-2' >
                                <TbHeartPlus />
                            </div>
                        </div>
                        <div className='flex justify-around items-center gap-3 border-2 px-8 py-3 rounded-lg' >
                            <div className='name-logo' >
                                {userData.Patient.name.split(' ')
                                    .map(word => word.charAt(0))
                                    .join('')
                                }
                            </div>
                            <div>
                                <strong className='text-md' >{userData.Patient.name}</strong>
                                <p className='text-sm'>{userData.Patient.contact_no}</p>
                                <p className='text-sm'>{moment().diff(moment(userData.Patient.dob), 'years') + ' years'}</p>
                                <p className='text-sm'>{userData.Patient.gender}</p>
                            </div></div>
                        <div className='border-2 px-8 py-3 rounded-lg relative'  >
                            {
                                userData?.address ? <div className='cursor-pointer' onClick={() => { setModal(true) }}>
                                    <strong>{userData?.address?.line}</strong>
                                    <p className='text-sm'>{userData?.address?.state}</p>
                                    <p className='text-sm'>{userData?.address?.district}</p>
                                    <p style={{
                                        border: '1px solid #049079',
                                        width: 'max-content'
                                    }} className='rounded-xl text-xs  px-2 py-1' >{userData?.address?.pincode}</p>
                                    <div className='absolute right-2 bottom-2' >
                                        <GrLocationPin />
                                    </div>
                                </div> : <p onClick={patientAddress?.data?.data && patientAddress?.data?.data?.length > 0 ? toggleModal : toggleCreateAddressForm} >No Address Found</p>
                            }

                        </div>
                    </div>
                    <div className='flex flex-row gap-x-10 items-center' >
                        <button onClick={handleShowPrescriptionModal} className={(userData?.prescription?.links?.length > 0 ? "" : "animate-bounce")}>
                            <img style={{ height: '60px' }} src={PrescriptionLogo} />
                        </button>
                        {
                            !order.orderId &&
                            <div>
                                <button className='p-2 text-lg  rounded-xl bg-teal-500 text-white-50 flex flex-row items-center gap-1  disabled:opacity-50' onClick={() => { handleConvertToOrder(order) }} disabled={!isEditable || isConverting}>{isConverting ? 'Converting...' : 'Convert to Order'}</button>
                            </div>
                        }
                        {
                            order.orderId &&
                            <div>
                                <button className='p-2 text-lg  rounded-xl bg-orange-500 text-white-50 flex flex-row items-center gap-1  disabled:opacity-50' onClick={() => { return navigate(`/order/edit/${order.orderId}`, { replace: true }) }} >Go to Order</button>
                            </div>
                        }
                        {/* Only show Send payment link button if payments don't cover the full order amount */}
                        {/* {!isFullyPaid && (
                            <div>
                                <button className='p-2 text-lg  rounded-xl bg-red-500 text-white-50 flex flex-row items-center gap-1 disabled:opacity-50' onClick={() => handlePaymentLinkModal(order)} disabled={!isEditable}>Send payment link</button>
                            </div>
                        )} */}
                        <div>
                            <button
                                className='p-2 text-lg rounded-xl bg-indigo-600 text-white-50 flex flex-row items-center gap-1 disabled:opacity-50'
                                onClick={handleSyncLsqMappingId}
                                disabled={isSyncingLsq}
                            >
                                {isSyncingLsq ? 'Syncing...' : 'Sync LSQ Mapping'}
                            </button>
                        </div>
                        <div>
                            <button className='p-2 text-lg px-7 font-medium font-sans shadow-soft-xl rounded-2xl bg-[#001524] text-white-50 disabled:opacity-50' onClick={() => {
                                if (checkForShowMissingTimingsError(order)) {
                                    navigate(`/drx/${quotationId}/quotation`, { replace: true })
                                }
                            }} >DRX</button>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    )
}

export default Header;